module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project row",
    class: {
      'project--visited': _vm.visited, 'project--archive': _vm.isArchive, 'row--condensed': _vm.isArchive
    }
  }, [_c('div', {
    staticClass: "row__side c-primary on-scroll__sub"
  }, [(_vm.isArchive) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }) : _c('h3', {
    ref: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    },
    on: {
      "mouseenter": _vm._onMouseEnter,
      "mouseleave": _vm._onMouseLeave
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main projects__item-description"
  }, [_c('div', {
    staticClass: "row__main-left on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.extra)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main-right on-scroll__sub",
    attrs: {
      "data-scroll": "third"
    }
  }, [_c('ui-button', {
    attrs: {
      "project": _vm.project
    },
    nativeOn: {
      "click": function($event) {
        _vm._onClickButton($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eec5f520"}!./src/components/project/project.component.html
// module id = 160
// module chunks = 1